import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import useValidate from '@/shared/lib/validate'
import { useLoadCabinetAdminMain } from '@/entities/Cabinet'
import { cloneDeep } from 'lodash'

const useModel = defineStore('cabinet_admin_main_form', () => {
  const { required } = useValidate()
  const scheduleList = ref<{ title: string; value: number }[]>([])

  /* Данные формы */
  const fields: {
    name: string
    parent_id: number
    old_parent_id: number
    serial_number: string | null
    soft_version: string
    time_zone: string
    summer_time: boolean
    schedule_id: number | null
    contactors_count: number
    protects_count: number
    address: string
    longitude: number | null
    latitude: number | null
  } = {
    name: '',
    parent_id: 0,
    old_parent_id: 0,
    serial_number: '',
    soft_version: '',
    time_zone: '3',
    summer_time: false,
    schedule_id: null,
    contactors_count: 0,
    protects_count: 0,
    address: '',
    longitude: null,
    latitude: null,
  }

  let data = ref({ ...fields })
  let origin = ref<any>({})

  /* Правила валидации */
  const rules = {
    name: [(value: string) => required(value)],
  }

  /**
   * Функция приведения к дефолтным значениям
   */
  const clearData = () => {
    Object.keys(data.value).forEach((key) => {
      data[key] = fields[key]
    })
  }

  /**
   * Обновляем данные origin
   */
  const updateOrigin = () => {
    origin.value = cloneDeep(data.value)
  }

  /**
   * Функция загрузки первоначальных данных
   */
  const loadData = () => {
    const result = useLoadCabinetAdminMain()

    watch(
      () => result.data.value,
      () => {
        if (result.data.value) {
          data.value = {
            ...data.value,
            ...result.data.value.data,
            old_parent_id: result.data.value.data.parent_id,
          }

          scheduleList.value = (result.data.value.payload?.schedules || []).map(
            (item: { id: number; name: string }) => ({
              title: item.name,
              value: item.id,
            }),
          )

          scheduleList.value.unshift({
            title: '',
            value: 0,
          })

          updateOrigin()
        }
      },
    )
    return result
  }

  return {
    data,
    rules,
    origin,
    scheduleList,

    clearData,
    loadData,
    updateOrigin,
  }
})

export default useModel
